<template>
	<landing-page-template2 />
</template>

<script>
import LandingPageTemplate2 from '@/views/JnsLandingPages/templates/LandingPageTemplate2.vue';

export default {
	name: 'LifeCirqulLandingPage',
	components: { LandingPageTemplate2 },
};
</script>

<style scoped>

</style>
